import { render } from "./PointsOfInterest.vue?vue&type=template&id=5edd1bc6&scoped=true"
import script from "./PointsOfInterest.vue?vue&type=script&lang=js"
export * from "./PointsOfInterest.vue?vue&type=script&lang=js"

import "./PointsOfInterest.vue?vue&type=style&index=0&id=5edd1bc6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edd1bc6"]])

export default __exports__